<template>
    <div class="number-manage">
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;height:50px;line-height:50px;padding-left:14px;">号码管理</div>
        <div style="position:relative;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
            <a-icon type="search" style="position:absolute;left:12px;top:13px;z-index:10" />
            <a-input v-model="filterPhone" @keyup.enter="inputQueryData" style="padding-left:32px;border:none;width:300px;height:38px;background:" placeholder="搜索标题（按Enter键搜索）" />
            <div style="float:right;margin:9px 25px 0 0;position:relative">
                <a-divider style="float:left;margin-top:8px;" type="vertical" />
                <img @click="setFilter" style="width:20px;cursor:pointer" title="筛选" src="../../assets/img/filter.svg" alt="">
                <span v-if="ifShowFilter" style="display:inline-block;width:12px;height:12px;border-radius:6px;position:absolute;right:-5px;top:0;background:red"></span>
            </div>
        </div>
        <div style="padding:16px 14px;">
            <a-table :data-source="numberData" :pagination='false' :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1 }" :rowKey="(record,index)=>{return record.id}">
                <a-table-column key="number" title="号码" data-index="number">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.number}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="belongCompany" title="开户单位" data-index="belongCompany">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.belongCompany}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="commodityName" title="所属商品" data-index="commodityName">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.commodityName}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="useCount" title="呼叫次数" data-index="useCount">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.useCount}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="answerPer" title="接通率" data-index="answerPer">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.answerPer}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="createTime" title="创建时间" data-index="createTime">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.createTime}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="status" title="状态" data-index="status">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.status==1?'启用':'停用'}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="allocateName" title="当前分配用户" data-index="allocateName">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.allocateName}}</span>
                        <a-icon v-if="record.allocateName!=null" style="cursor:pointer;font-size:14px;float:right;margin-top:3px;color:rgba(204, 204, 204, 1)" @click="changeRemark( record.id)" type="search" />
                    </template>
                </a-table-column>
                <a-table-column key="lastAllocateTime" title="分配时间" data-index="lastAllocateTime">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.lastAllocateTime}}</span>
                    </template>
                </a-table-column>
                <a-table-column key="allocateCount" title="当前用户数量" data-index="allocateCount">
                    <template slot-scope="text, record">
                        <span style="margin-right:8px">{{record.allocateCount}}</span>
                    </template>
                </a-table-column>
            </a-table>
            <div>
                <a-select @change="changeDays" v-model="callTimes" style="width: 100%;width:150px;float:left;margin-top:8px;">
                    <a-select-option :value="1" key='1'>
                        1天内
                    </a-select-option>
                    <a-select-option :value="7" key='7'>
                        7天内
                    </a-select-option>
                    <a-select-option :value="30" key='30'>
                        30天内
                    </a-select-option>
                    <a-select-option :value="60" key='60'>
                        60天内
                    </a-select-option>
                    <a-select-option :value="90" key='90'>
                        90天内
                    </a-select-option>
                    <a-select-option :value="180" key='180'>
                        180天内
                    </a-select-option>
                    <a-select-option :value="360" key='360'>
                        360天内
                    </a-select-option>
                </a-select>
                <div style="float:left;margin-top:8px;" v-if="selectedRowKeys1.length!=0">
                    <span style="color:rgba(18, 18, 18, 1);font-size:12px;">已选中{{selectedRowKeys1.length}}项</span>
                    <a-divider type="vertical" style="margin:0 15px;"/>
                    <div style="display:inline-block;">
                        <img style="width:18px;margin-right:5px;float:left;margin-top:3px;" src="../../assets/img/user.svg" alt="">
                        <span @click="editState" style="color:rgba(158, 172, 196, 1);font-size:12px;cursor:pointer;">修改状态</span>
                    </div>
                    <div style="display:inline-block;">
                        <img style="width:18px;margin:0 5px 0 31px;float:left;margin-top:3px;" src="../../assets/img/window.svg" alt="">
                        <span @click="selectNumber" style="color:rgba(158, 172, 196, 1);font-size:12px;cursor:pointer;">分配给指定客户</span>
                    </div>
                </div>
                <div style="float:right">
                    <a-pagination 
                        style="float:right;margin:12px 0 0 8px"
                        v-model="currentPage"
                        :page-size-options="pageSizeOptions"
                        :total="total"
                        show-size-changer
                        :page-size="pageSize"
                        @change="pageChange"
                        @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                        </template>
                    </a-pagination>
                    <span style="margin-top:18px;float:right">共{{ total }}条</span>
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="chooseAccountModal" :closable='false' footer='' :zIndex='10000000' width='1020px'>
            <div class="choose-account-modal">
                <div class="add-title">
                    <span>选择账号</span>
                    <a-icon @click="cancelChooseAccount" type="close" />
                </div>
                <div class="choose-account-data">
                    <a-row>
                        <a-col :span="13">
                            <div class="account-left-content">
                                <div class="sort-condition">
                                    <a-input v-model="searchNum" @input='inputChange()' style="width:100%" placeholder="搜索号码" />
                                </div>
                                <div class="account-table">
                                    <a-table
                                        :row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange2 }"
                                        :columns="columns1"
                                        :data-source="numberData1"
                                        :pagination='false'
                                        :scroll="{ x: '100%', y: 240}"
                                        :rowKey="(record,index)=>{return record.id}"
                                    >
                                    </a-table>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="11">
                            <div class="account-right-content">
                                <div class="choosed-title">
                                    <span>已选择：{{ selectedRowKeys2.length }}条</span>
                                    <span @click="cleanSelected">清空</span>
                                </div>
                                <div class="choosed-content">
                                    <div class="choosed-item" v-for="(item,index) in selectedRowKeys2" :key='index'>
                                        <!-- <a-icon class="choosed-phone" type="phone" /> -->
                                        <span class="choosed-number">{{dataObj[item]}}</span>
                                        <a-icon class="choosed-close" @click="deleteSelectedNum(index)" type="close" />
                                    </div>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelChooseAccount">取消</a-button>
                        <a-button type="primary" @click="queryIfNewGateway">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="changeStateModal" footer='' width='440px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>修改状态</span>
                    <a-icon @click="cancelChangeState" type="close" />
                </div>
                <div class="modal-info">
                    <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-right:52px;">是否启用</span>
                    <a-switch v-model="ifUsed" />
                    <span v-if="!ifUsed" style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:8px;">停用</span>
                    <span v-if="ifUsed" style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:8px;">启用</span>
                </div>
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelChangeState">取消</a-button>
                    <a-button type="primary" @click="sureChangeState">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="currentAllocationModal" :closable='false' footer='' :zIndex='10000000' width='1020px'>
            <div class="choose-account-modal">
                <div class="add-title">
                    <span>当前分配用户</span>
                    <a-icon @click="cancelAllocation" type="close" />
                </div>
                <div class="choose-account-data">
                    <a-table :data-source="currentAllocationData" :pagination='false' :rowKey="(record,index)=>{return record.id}">
                        <a-table-column key="name" title="用户名称" data-index="name">
                            <template slot-scope="text, record">
                                <span style="margin-right:8px">{{record.name}}</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="allocateTime" title="分配时间" data-index="allocateTime">
                            <template slot-scope="text, record">
                                <span style="margin-right:8px">{{record.allocateTime}}</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="id" title="查看用户详情" data-index="id">
                            <template slot-scope="text, record">
                                <span @click="viewDel(record.id)" style="color:rgba(24, 144, 255, 1);font-size:13px;text-decoration: underline;cursor: pointer">查看用户详情</span>
                            </template>
                        </a-table-column>
                    </a-table>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAllocation">取消</a-button>
                        <a-button type="primary" @click="sureAllocation">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="filterModal" :closable='false' footer='' :zIndex='1000' width='500px'>
            <div class="choose-account-modal">
                <div class="add-title">
                    <span>设置筛选条件</span>
                    <span @click="clearFilter" style="color:rgba(24, 144, 255, 1);font-size:13px;font-weight:normal;margin-left:16px;cursor:pointer;">重置</span>
                    <a-icon @click="cancelFilter" type="close" />
                </div>
                <div style="padding:20px 24px;">
                    <div style="display:flex;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">号码</span>
                        <div style="flex:1">
                            <a-input v-model="filterPhone" placeholder="输入的值" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">呼叫次数</span>
                        <div style="flex:1;display: flex;">
                            <a-input-number style="width:150px;" :min="0" v-model="useCountQ" placeholder="输入的值" />
                            <span style="flex:1;text-align: center">—</span>
                            <a-input-number style="width:150px;" :min="0"  v-model="useCountz" placeholder="输入的值" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">接通率</span>
                        <div style="flex:1;display: flex;">
                            <a-input-number style="width:150px;" :min="0"  v-model="answerPerQ" placeholder="输入的值" />
                            <span style="flex:1;text-align: center">—</span>
                            <a-input-number style="width:150px;" :min="0"  v-model="answerPerZ" placeholder="输入的值" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">开户单位</span>
                        <div style="flex:1">
                            <a-input v-model="filterAccount" placeholder="输入的值" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">所属商品</span>
                        <div style="flex:1">
                            <a-select mode="multiple" :filter-option="filterOption" v-model="selectedGood" style="width: 100%;border:1px solid rgba(158, 172, 196, 0.3)">
                                <a-select-option :value="item.id" v-for="(item, index) in goodsList" :key='index'>
                                    {{item.name}}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">创建时间</span>
                        <div style="flex:1">
                            <a-range-picker valueFormat="YYYY-MM-DD"  v-model="createTime" style="width:100%" format="YYYY-MM-DD" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">状态</span>
                        <div style="flex:1">
                            <a-select v-model="status" style="width: 100%;border:1px solid rgba(158, 172, 196, 0.3)">
                                <a-select-option value="1" key='1'>
                                    启用
                                </a-select-option>
                                <a-select-option value="2" key='2'>
                                    停用
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">当前分配用户</span>
                        <div style="flex:1">
                            <a-input-search v-model="currentAllocationText" placeholder="请选择值" style="" @search="onSearch" />
                        </div>
                    </div>
                    <div style="display:flex;margin-top:12px;">
                        <span style="display:inline-block;width:110px;color:rgba(18, 18, 18, 1);font-size:13px;line-height:32px;">绑定用户</span>
                        <div style="flex:1">
                            <a-select v-model="hasUser" style="width: 100%;border:1px solid rgba(158, 172, 196, 0.3)">
                                <a-select-option value="1" key='1'>
                                    未绑定用户
                                </a-select-option>
                                <a-select-option value="2" key='2'>
                                    已绑定用户
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelFilter">取消</a-button>
                        <a-button type="primary" @click="sureFilter">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="needNewGatewayModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>提示</span>
                    <a-icon @click="cancelNeedNewGateway" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>本次分配涉及新网关创建</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelNeedNewGateway">取消</a-button>
                        <a-button type="primary" @click="sureChooseAccount">确认分配</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <ListDetails ref="listDetails" ></ListDetails>
    </div>
</template>

<script>
    import ListDetails from '../../components/ListDetails'
    export default {
        name: 'Chat',
        components: {  ListDetails },
        data() {
            return {
                dataTitle: '',
                numberData: [],
                selectedRowKeys1: [],
                currentPage: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '50 ','100', '200', '500', '1000'],
                total: 0,
                chooseAccountModal: false,
                selectedRowKeys2: [],
                dataObj: {},
                numberData1: [],
                dataId: '',
                searchNum: '',
                columns1: [
                    {
                        dataIndex: 'phone',
                        scopedSlots: {
                            customRender: 'phone'
                        },
                        key: 'phone',
                        title: '账号'
                    },
                    {
                        dataIndex: 'id',
                        scopedSlots: {
                            customRender: 'id'
                        },
                        key: 'id',
                        title: '账号ID'
                    },
                    {
                        dataIndex: 'name',
                        scopedSlots: {
                            customRender: 'name'
                        },
                        key: 'name',
                        title: '姓名'
                    },
                ],
                changeStateModal: false,
                ifUsed: false,
                currentAllocationModal: false,
                numberId: '',
                currentAllocationData: [],
                filterModal: false,
                goodsList: [],
                selectedGood: [],
                createTime: null,
                status: '',
                filterPhone: '',
                filterAccount: '',
                currentAllocationText: '',
                countFlag: false,
                passModuleId: 2,
                filterNum: 0,
                ifShowFilter: false,
                hasUser: '',
                callTimes: '',
                needNewGatewayModal: false,
                useCountQ: null,
                useCountz: null,
                answerPerQ: null,
                answerPerZ: null,
            }   
        },
        methods: {
            queryNumberData() {
                let str = '', str2 = ''
                if(this.selectedRowKeys2.length > 0){
                    for(let i = 0; i < this.selectedRowKeys2.length; i++){
                        str+=this.selectedRowKeys2[i]+","
                    }
                }
                if(this.selectedGood.length > 0){
                    for(let i = 0; i < this.selectedGood.length; i++){
                        str2+=this.selectedGood[i]+","
                    }
                }
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/numberList', 
                        params: {
                            current: this.currentPage,
                            size: this.pageSize,
                            number: this.filterPhone,
                            belongCompany: this.filterAccount,
                            commodityIds: str2,
                            createTimeQ: this.createTime!=null?this.createTime[0]:'',
                            createTimeZ: this.createTime!=null?this.createTime[1]:'',
                            status: this.status,
                            userIds: str,
                            hasUser: this.hasUser,
                            days: this.callTimes,
                            useCountQ: this.useCountQ,
                            useCountz: this.useCountz,
                            answerPerQ: this.answerPerQ,
                            answerPerZ: this.answerPerZ,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.numberData = response.data.data.records
                        this.total = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeDays() {
                this.queryNumberData()
            },
            inputQueryData() {
                this.queryNumberData()
            },
            onSelectChange1(selectedRowKeys) {
                this.selectedRowKeys1 = selectedRowKeys;
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryNumberData()
            },
            onShowSizeChange(current, pageSize) {
                this.pageSize = pageSize;
                this.currentPage = current
                this.queryNumberData()
            },
            changeRemark(id) {
                this.numberId = id
                this.currentAllocationModal = true
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/allocateUserList', 
                        params: {
                            numberId: this.numberId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.currentAllocationData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelChooseAccount() {
                this.chooseAccountModal = false
            },
            queryIfNewGateway() {
                this.chooseAccountModal = false
                if(this.filterModal) {
                    let str = ''
                    for(let i = 0; i < this.selectedRowKeys2.length; i++){
                        str+= this.dataObj[this.selectedRowKeys2[i]]+'、'
                    }
                    let newStr = str.substring(0, str.length - 1);
                    this.currentAllocationText = newStr
                }else{
                    this.axios.post('/api/number/manage/hasNewGateway', {
                        numberIdList: this.selectedRowKeys1,
                        userIdList: this.selectedRowKeys2,
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            if(response.data.data.needNewGateway){
                                this.needNewGatewayModal = true
                            }else{
                                this.sureChooseAccount()
                            }
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    })
                    .catch(error=> {
                        console.log(error)
                    })
                }
            },
            sureChooseAccount() {
                this.chooseAccountModal = false
                this.needNewGatewayModal = false
                // if(this.filterModal) {
                //     let str = ''
                //     for(let i = 0; i < this.selectedRowKeys2.length; i++){
                //         str+= this.dataObj[this.selectedRowKeys2[i]]+'、'
                //     }
                //     let newStr = str.substring(0, str.length - 1);
                //     this.currentAllocationText = newStr
                // }else{
                    this.axios.post('/api/number/manage/allocate', {
                        numberIdList: this.selectedRowKeys1,
                        userIdList: this.selectedRowKeys2,
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            this.$message.success('分配成功')
                            this.chooseAccountModal = false
                            this.selectedRowKeys1 = []
                            this.selectedRowKeys2 = []
                            this.queryNumberData()
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    })
                    .catch(error=> {
                        console.log(error);
                    });
                // }
            },
            cancelNeedNewGateway() {
                this.needNewGatewayModal = false
            },
            onSelectChange2(selectedRowKeys) {
                this.selectedRowKeys2 = selectedRowKeys;
            },
            selectNumber() {
                this.chooseAccountModal = true
                this.flag = 0
                this.queryAccountData()
            },
            inputChange() {
                clearTimeout(this.timer)
                this.timer = setTimeout(()=>{
                    this.queryAccountData()
                },1500)
            },
            queryAccountData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/userList', 
                        params: {
                            phone: this.searchNum,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.numberData1 = response.data.data
                        let arr = response.data.data
                        for(let i = 0; i < arr.length; i++){
                            this.dataObj[arr[i]['id']] = arr[i]['name']
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cleanSelected() {
                this.selectedRowKeys2 = []
            },
            deleteSelectedNum(index) {
                this.selectedRowKeys2.splice(index, 1);
            },
            editState() {
                this.changeStateModal = true
            },
            cancelChangeState() {
                this.changeStateModal = false
            },
            sureChangeState() {
                this.changeStateModal = false
                this.axios.post('/api/number/manage/updateStatus', {
                    numberIdList: this.selectedRowKeys1,
                    status: this.ifUsed==false?2:1,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryNumberData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            cancelAllocation() {
                this.currentAllocationModal = false
            },
            sureAllocation() {
                this.currentAllocationModal = false
            },
            viewDel(id) {
                this.currentAllocationModal = false
                this.countFlag = true
                this.$refs.listDetails.getPassModuleId(2)
                this.$refs.listDetails.changeAffairBoolValue()
                this.$refs.listDetails.getDataIdValue(id)
                this.$refs.listDetails.queryDetailsData()
                this.$refs.listDetails.queryTabList()
                this.$refs.listDetails.setCurrentTab()
                this.$refs.listDetails.queryUserList()
            },
            setFilter() {
                this.filterModal = true
            },
            cancelFilter() {
                this.filterModal = false
            },
            sureFilter() {
                this.filterModal = false
                if(this.filterPhone!=''||this.filterAccount!=''||this.selectedGood.length!=0||this.createTime!=null||this.status!=''||this.selectedRowKeys2.length!=0||this.hasUser!=''){
                    this.ifShowFilter = true
                }else{
                    this.ifShowFilter = false
                }
                this.queryNumberData()
            },
            queryGoodList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/commodityList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.goodsList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onSearch() {
                this.queryAccountData()
                this.chooseAccountModal = true
            },
            clearFilter() {
                this.filterPhone = ''
                this.filterAccount = ''
                this.selectedGood = []
                this.createTime = null
                this.status = ''
                this.selectedRowKeys2 = []
                this.currentAllocationText = ''
                this.hasUser = ''
            },
            filterOption(inputValue, option) {
                return option.componentOptions.children[0].text.includes(inputValue)
            },
        },
        mounted: function() {
            this.queryNumberData()
            this.queryGoodList()
            document.onclick = ()=> {
                if(this.countFlag){
                    setTimeout(()=>{
                        this.$refs.listDetails.changePersonBoxBoolValue()
                        this.$refs.listDetails.changeTagsBoolValue()
                    },200)
                }
                this.$forceUpdate();
            }
        }
    }
</script>

<style scoped lang="less">
    .number-manage{
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .choose-account-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .choose-account-data{
            padding: 24px;
            .account-left-content{
                padding-right: 24px;
                border-right: 1px solid rgba(229, 229, 229, 1);
                .account-table{
                    margin-top: 24px;
                }
                .pagination-table{
                    float: right;
                    padding-top: 24px;
                }
                .sort-condition{
                    input{
                        width: 150px;
                    }
                    .sort-list{
                        display: inline-block;
                        padding: 0 12px;
                        height: 32px;
                        line-height: 32px;
                        background: #fafafa;
                        margin-left: 10px;
                        font-size: 14px;
                        cursor: pointer;
                        border-radius: 4px;
                    }
                    span.active{
                        background: #1890FF;
                        color: #fff;
                    }
                }
            }
            .account-right-content{
                padding-left: 24px;
                .choosed-title{
                    span:nth-child(1){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                    span:nth-child(2){
                        color: rgba(24, 144, 255, 1);
                        font-size: 14px;
                        float: right;
                        cursor: pointer;
                    }
                }
                .choosed-content{
                    margin-top: 24px;
                    max-height: 305px;
                    overflow-y: auto;
                    .choosed-item{
                        display: inline-block;
                        min-width: 132px;
                        height: 32px;
                        margin: 0 8px 8px 0;
                        background: rgba(121, 136, 155, 0.1);
                        text-align: center;
                        line-height: 32px;
                        padding: 0 8px;
                        .choosed-phone{
                            color: rgba(121, 136, 155, 1);
                            font-size: 16px;
                            float: left;
                            margin-top: 7px;
                        }
                        .choosed-number{
                            color: rgba(80, 80, 80, 1);
                            font-size: 14px;
                            display: inline-block;
                            min-width: 84px;
                            overflow: hidden;
                        }
                        .choosed-close{
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                            float: right;
                            margin-top: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
    .delete-modal{
        .modal-info{
            display: flex;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
        }
    }
    .modal-public{
        .modal-title{
            height: 55px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding: 20px 20px 0 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                color: rgba(158, 172, 196, 1);
                float: right;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .modal-info{
            padding: 16px 20px 24px 24px;
            .modal-content{
                flex: 1;
                margin-left: 20px;
                .modal-tip{
                    color: rgba(18, 18, 18, 1);
                    font-size: 16px;
                }
                .modal-des{
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                    margin-top: 12px;
                }
            }
        }
        .btn-group{
            text-align: right;
            padding: 0 20px 20px 0;
            button{
                width: 64px;
                height: 28px;
                font-size: 13px;
                text-align: center;
            }
            button:nth-child(1){
                margin-right: 8px;
                color: rgba(158, 172, 196, 1);
                border: none;
            }
            button:nth-child(2){
                color: #fff;
                background: rgba(58, 220, 255, 1);
            }
        }
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 24px 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                padding: 0 16px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
        .pic-content{
            text-align: center;
            img{
                width: 200px;
            }
        }
    }
</style>